export const POST_ERROR_MESSAGE = 'Error while posting post.';
export const FAILED_TO_SEND_MESSAGE = 'Failed to send message';
export const REACTION_FAILED = 'Reaction failed';
export const MESSAGE_COPIED = 'Message copied!';
export const FAILED_CHAT_MESSAGE = 'Failed to reset chat';
export const CHAT_RESET_SUCCESSFULLY = 'Chat has been reset successfully!';
export const CHATBOT_SERVICE_UNAVAILABLE = 'Chatbot service is temporarily unavailable. Please try again later';
export const CHATBOT_SERVICE_UNAVAILABLE_ERROR_MESSAGE = '\'ChatBot\' object has no attribute';
export const FAILED_TO_GET_RESPONSE_FROM_CHATBOT = 'Failed to get response from chatbot';
